import type { CityConfig } from "../city-template/types";

export const hooksettConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — NH Dept of State Vital Records", href: "https://sos.nh.gov/vital-records/", description: "Official New Hampshire vital records office in Concord" },
    { label: "Marriage Licenses — Merrimack County Clerk", href: "https://www.merrimackcounty.net/", description: "Merrimack County Clerk — marriage license issuance" },
    { label: "Divorce Records — Merrimack County Superior Court", href: "https://www.courts.nh.gov/", description: "Merrimack County Superior Court — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of NH SOS for online vital record orders" },
  ],
  city: "Hooksett",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "hooksett",
  route: "/cities/hooksett",
  title: "Emergency Passport Hooksett, NH | Fast Passport Renewal & Expedited Help",
  metaDescription: "Emergency passport and expedited passport services in Hooksett, NH — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Merrimack County and Manchester-Concord corridor travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Hooksett, NH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Hooksett and central New Hampshire travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Hooksett%20New%20Hampshire%20scenic%20view%20along%20the%20Merrimack%20River%20with%20the%20historic%20Hooksett%20village%2C%20stone%20arch%20bridge%20over%20the%20river%2C%20I-93%20corridor%20with%20rolling%20hills%2C%20New%20England%20autumn%20foliage%20with%20red%20and%20orange%20maple%20trees%2C%20warm%20golden%20hour%20light%2C%20small%20suburban%20town%20with%20green%20landscapes%2C%20clean%20photorealistic%20scene%2C%20no%20visible%20text%20or%20people%2C%20warm%20earth%20tones%20and%20soft%20sky%2C%20professional%20landscape%20photography&width=1800&height=700&seq=hooksett-nh-hero-001&orientation=landscape",
  heroImageAlt: "Hooksett New Hampshire scenic view along the Merrimack River with historic stone bridge and autumn foliage",
  geoPosition: "43.0967;-71.4651",
  geoPlacename: "Hooksett, New Hampshire",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "10 Causeway St Suite 247, Boston, MA 02222",
    distance: "Located in downtown Boston — approximately 55–70 minutes from Hooksett via I-93",
  },
  nearbyCitiesZips: [
    { name: "Hooksett", zips: "03106" },
    { name: "Manchester", zips: "03101–03111" },
    { name: "Concord", zips: "03301–03305" },
    { name: "Bow", zips: "03304" },
    { name: "Auburn", zips: "03032" },
    { name: "Candia", zips: "03034" },
    { name: "Allenstown", zips: "03275" },
    { name: "Pembroke", zips: "03275" },
    { name: "Suncook", zips: "03275" },
    { name: "Goffstown", zips: "03045" },
    { name: "Bedford", zips: "03110" },
    { name: "Amherst", zips: "03031" },
    { name: "Merrimack", zips: "03054" },
    { name: "Londonderry", zips: "03053" },
    { name: "Derry", zips: "03038" },
    { name: "Weare", zips: "03281" },
    { name: "Henniker", zips: "03242" },
    { name: "Hopkinton", zips: "03229" },
    { name: "Dunbarton", zips: "03046" },
    { name: "New Boston", zips: "03070" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Merrimack County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Manchester", route: "/manchester" },
    { name: "Concord", route: "/concord-nh" },
    { name: "Nashua", route: "/cities/nashua" },
    { name: "Derry", route: "/cities/derry" },
    { name: "Londonderry", route: "/cities/londonderry" },
    { name: "Portsmouth", route: "/cities/portsmouth" },
    { name: "Dover", route: "/cities/dover" },
    { name: "Keene", route: "/cities/keene" },
  ],
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeNote: "Fast Passport Center serves Hooksett remotely via secure courier. We do not have a walk-in office in Hooksett — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Merrimack County travelers.",
  fpcOfficeDistance: "Serving all of Merrimack County and the Manchester-Concord corridor",
  serviceAreaIntro: "From the neighborhoods near Cawley Middle School to the River Road area, from the Hooksett Village commercial district to the Whitehall Road corridor — Fast Passport Center serves the entire Hooksett community. We regularly help travelers from Manchester, Concord, Bow, and Auburn get their passports fast.",
  nearbyCitiesIntro: "We serve all Hooksett neighborhoods and nearby central New Hampshire cities including Manchester, Concord, Bow, Auburn, Candia, Allenstown, Pembroke, Suncook, Goffstown, Bedford, Amherst, Merrimack, Londonderry, Derry, Weare, Henniker, and Hopkinton. If you are in the greater Hooksett area, we have you covered.",
  howItWorksIntro: "Most Hooksett travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency.",
  mistakesIntro: "With Manchester-Boston Regional Airport (MHT) just 15 minutes away and easy access to Boston Logan, Hooksett travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Hooksett and Merrimack County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Hooksett? Here are the most common ones we hear from central New Hampshire travelers.",
  statePageRoute: "/states/new-hampshire",
  statePageName: "New Hampshire",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Hooksett international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Hooksett, NH",
      rating: 5,
      text: "My husband's business trip to Germany was in 3 days and his passport had expired. Fast Passport Center got it renewed in 36 hours. Absolutely incredible.",
      service: "Emergency Passport",
    },
    {
      name: "Michael D.",
      location: "Manchester, NH",
      rating: 5,
      text: "Needed to renew for a family vacation to Italy. The process was smooth from start to finish, and I had my passport in 4 days. Great service.",
      service: "Passport Renewal",
    },
    {
      name: "Amanda R.",
      location: "Bow, NH",
      rating: 5,
      text: "Lost my passport the week before my trip to Mexico. They walked me through the DS-64 process and got me a replacement in 2 days. So grateful.",
      service: "Lost Passport",
    },
    {
      name: "David S.",
      location: "Concord, NH",
      rating: 5,
      text: "As a frequent international traveler from the capital region, I need reliable passport service. Fast Passport Center has never let me down. Professional and fast.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "hooksett-nh-1",
      name: "Hooksett Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "20 Riverside Dr",
      city: "Hooksett",
      state: "NH",
      zip: "03106",
      phone: "(603) 623-8222",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.8 miles from downtown Hooksett",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Hooksett. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "hooksett-nh-2",
      name: "Manchester Post Office — Downtown",
      type: "USPS Passport Acceptance Facility",
      address: "1000 Elm St",
      city: "Manchester",
      state: "NH",
      zip: "03101",
      phone: "(603) 624-4744",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5.5 miles from Hooksett",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for the Manchester-Concord corridor. Extended hours available. Book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "hooksett-nh-3",
      name: "Concord Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "18 Loews Dr",
      city: "Concord",
      state: "NH",
      zip: "03301",
      phone: "(603) 224-0631",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8.5 miles from Hooksett",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary facility for Merrimack County. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "hooksett-nh-4",
      name: "Bow Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "546 Bow Center Rd",
      city: "Bow",
      state: "NH",
      zip: "03304",
      phone: "(603) 224-4854",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "3.2 miles from Hooksett",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Bow and eastern Hooksett residents. Limited hours — book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "hooksett-nh-5",
      name: "Pembroke Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6 S Pembroke Rd",
      city: "Pembroke",
      state: "NH",
      zip: "03275",
      phone: "(603) 485-9631",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "4.0 miles from Hooksett",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Suncook Valley and Allenstown residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "hooksett-nh-6",
      name: "Hooksett Town Clerk",
      type: "Town Clerk Passport Acceptance",
      address: "35 Main St",
      city: "Hooksett",
      state: "NH",
      zip: "03106",
      phone: "(603) 485-4273",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from Town Hall",
      website: "https://www.hooksettcty.org/",
      websiteLabel: "Hooksett Town Clerk",
      notes: "Major municipal facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Hooksett photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Merrimack County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Hooksett applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Hooksett families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Hooksett travelers often assume standard processing will be fine. It takes 6–13 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Hooksett." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Hooksett address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Hooksett before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Hooksett for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most Merrimack County travelers." },
    { q: "How fast can I renew my passport in Hooksett?", a: "Fast Passport Center offers fast passport renewal in Hooksett in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Hooksett in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Hooksett?", a: "Same-day passport appointments are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Hooksett residents." },
    { q: "Can I expedite a child passport in Hooksett?", a: "Yes. Fast Passport Center expedites child passports in Hooksett for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Hooksett with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Hooksett?", a: "With Fast Passport Center's emergency courier service, Hooksett travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to visit the Boston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Hooksett?", a: "Popular options include the Hooksett Post Office (03106), Manchester Downtown Post Office (03101), Concord Post Office (03301), and Hooksett Town Clerk (03106). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Hooksett?", a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in a nearby town like Manchester or Concord?", a: "We serve all of the Merrimack County and Manchester-Concord corridor including Manchester, Concord, Bow, Auburn, Candia, Allenstown, Pembroke, Suncook, Goffstown, Bedford, Amherst, and Merrimack. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Hooksett?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Hooksett", address: "1225 Hooksett Rd, Hooksett, NH 03106", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Hooksett", address: "1301 Hooksett Rd, Hooksett, NH 03106", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "UPS Store — Hooksett", address: "1190 Hooksett Rd, Hooksett, NH 03106", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Manchester", address: "725 Gold St, Manchester, NH 03103", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Rite Aid — Manchester", address: "1000 Elm St, Manchester, NH 03101", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "FedEx Office — Manchester", address: "1000 Elm St, Manchester, NH 03101", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
    { name: "Costco — Manchester", address: "1000 Elm St, Manchester, NH 03101", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM", website: "https://www.costco.com/" },
    { name: "Walgreens — Concord", address: "131 Loudon Rd, Concord, NH 03301", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    { name: "DMV — Manchester", address: "23 Hazard Ave, Manchester, NH 03109", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID and driver's license renewals. Passport-ready photo services. Appointment required.", featured: true },
    { name: "DMV — Concord", address: "23 Hazen Dr, Concord, NH 03301", hours: "Mon–Fri: 8AM–5PM", note: "Passport-ready photo services available. Online appointment booking.", featured: false },
    { name: "DMV — Nashua", address: "33 Main St, Nashua, NH 03060", hours: "Mon–Fri: 8AM–5PM", note: "Full-service center for southern New Hampshire residents.", featured: false },
    { name: "DMV — Epping", address: "101 Calef Hwy, Epping, NH 03042", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID processing. Walk-ins limited — book online first.", featured: true },
  ],
  airports: [
    { code: "MHT", name: "Manchester-Boston Regional Airport", distance: "12 miles from Hooksett", address: "1 Airport Rd, Manchester, NH 03103", note: "Closest major commercial airport for Hooksett travelers. International flights to Canada and Europe. Major domestic hub.", flightUrl: "https://www.flymanchester.com/", flightLabel: "MHT Flight Info", featured: true },
    { code: "BOS", name: "Boston Logan International Airport", distance: "65 miles from Hooksett", address: "1 Harborside Dr, Boston, MA 02128", note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-93.", flightUrl: "https://www.massport.com/logan-airport", flightLabel: "Logan Airport", featured: false },
    { code: "CON", name: "Concord Municipal Airport", distance: "12 miles from Hooksett", address: "71 Airport Rd, Concord, NH 03301", note: "Regional airport for general aviation. Charter and private flights available.", flightUrl: "https://www.concordairport.org/", flightLabel: "Concord Airport", featured: false },
  ],
};